import { Pipe, PipeTransform } from '@angular/core';
import { COUNTRIES } from '../constants';
import { Base } from '../models';

@Pipe({
  name: 'countriesCodeToName',
})
export class CountriesCodeToNamePipe implements PipeTransform {
  transform(countriesCode: string[]): string {
    return COUNTRIES.filter((country: Base) => countriesCode.includes(country.id))
      .map((country: Base) => country.name)
      .join(', ');
  }
}
